<div class="modal-window">
  <div class="modal-window-content">
    <div class="modal-window-header">
      <div class="modal-window-header-title">
        <svg
          class="modal-window-header-title-icon"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
            fill="#BB0000"
          />
          <path d="M15 8.25V15.75" stroke="white" stroke-width="3" stroke-linecap="round" />
          <path
            d="M15 22.5C15.8284 22.5 16.5 21.8284 16.5 21C16.5 20.1716 15.8284 19.5 15 19.5C14.1716 19.5 13.5 20.1716 13.5 21C13.5 21.8284 14.1716 22.5 15 22.5Z"
            fill="white"
          />
        </svg>
        <h4 style="margin-right: auto; margin-top: 0" [innerHTML]="emergencyNotifications" class="modal-header-title-text"></h4>
        <div class="modal-window-header-close">
          <span style="margin-top: -8px" (click)="close()">
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.3184 1.3313L1.05859 20.7807" stroke="#0071C2" stroke-width="2" />
              <path d="M1.32812 1.07178L21.5879 20.5212" stroke="#0071C2" stroke-width="2" />
              <path d="M21.3184 1.3313L1.05859 20.7807" stroke="#0071C2" stroke-width="2" />
              <path d="M1.32812 1.07178L21.5879 20.5212" stroke="#0071C2" stroke-width="2" />
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="modal-window-body">
      <div class="modal-window-body-content">
        <div class="modal-window-body-content-text">
          <aside [innerHTML]="emergencyHeader"></aside>
        </div>
      </div>
    </div>
  </div>
</div>
